import { render, staticRenderFns } from "./popularPosts.vue?vue&type=template&id=6920cf8f&"
import script from "./popularPosts.vue?vue&type=script&lang=ts&"
export * from "./popularPosts.vue?vue&type=script&lang=ts&"
import style0 from "./popularPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports